import { render, staticRenderFns } from "./DyestuffForm2.vue?vue&type=template&id=58fc30de&scoped=true"
import script from "./DyestuffForm2.vue?vue&type=script&lang=ts"
export * from "./DyestuffForm2.vue?vue&type=script&lang=ts"
import style0 from "./DyestuffForm2.vue?vue&type=style&index=0&id=58fc30de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58fc30de",
  null
  
)

export default component.exports